export default __webpack_public_path__ + "static/media/mobius.edebc64c.svg";